require("./globalErrorHandler");

import BabelPolyfill from "babel-polyfill";
import React, { Component } from "react";
import ReactDOM from "react-dom";
import thunkMiddleware from "redux-thunk";
import { compose, createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import createLogger from "redux-logger";
import { hashHistory } from "react-router";

import reducers from "./reducers/reducers";
import AppRouter from "./AppRouter";
import { initialiseNightlyUpdate } from "./appUpdate";

require("../stylesheets/pure.css");
require("../stylesheets/grids-responsive.css");
require("../stylesheets/react-autosuggest.css");
require("../stylesheets/react-tagsinput.css");
require("react-day-picker/lib/style.css");
require("react-select/dist/react-select.css");
require("../stylesheets/custom.less");

initialiseNightlyUpdate();

const logger = createLogger();

const store = createStore(reducers, compose(
    applyMiddleware(thunkMiddleware, logger),
    window.devToolsExtension ? window.devToolsExtension() : f => f
));

ReactDOM.render(
    <Provider store={store}>
        <AppRouter history={hashHistory} />
    </Provider>
    , document.getElementById("root"));



/** WEBPACK FOOTER **
 ** ./src/main/javascript/index.js
 **/